// learn-page.bookmarklet.js — "Learn Page" bookmarklet payload.
//
// Extracted verbatim from settings-panel.js (Stage A of the monolith split).
// Pure: takes a derived palette `p` (see _deriveBookmarkletPalette in
// settings-panel.js) and returns the bookmarklet source string. The template
// content is intentionally flush-left — leading whitespace would be injected
// into the generated javascript: URL, so do not re-indent the body.
//
// The saved template (`pageExtractorFields`) supports two selector-less field
// formats — 'blank' (an empty cell / gap) and 'url' (the page URL, kept last
// while picking) — plus per-field ▲/▼ reordering, and a persisted paste
// layout (`pageExtractorLayout`: 'row' = one tab-separated Excel row,
// 'doc' = vertical markdown). getVal/fmtMd/fmtCell are intentionally
// duplicated in extract.bookmarklet.ts (each payload must be self-contained);
// keep both copies in sync.
//
// The panel runs on foreign pages where base.css can't reach, so pexStyle
// inlines the no-visible-scrollbars rules scoped to #pex-panel/#pex-preview
// (keep in sync with web/css/base.css, per CLAUDE.md). Icons follow the app's
// icon language — the mobile keyboard row's `_svg` conventions (editor/
// mobile-keyboard-accessory.ts): 24×24 viewBox, stroke=currentColor,
// stroke-width 2.1, round caps/joins. SVGs get pointer-events:none so the
// delegated onClick's e.target stays the button carrying data-a. Status
// colours come from the derived palette (p.success…), never hardcoded hex.

// @ts-check

/**
 * @param {any} p - the derived bookmarklet palette.
 * @returns {string} the bookmarklet source string.
 */
export function buildLearnSrc(p: any) {
  return `(function(){
var STORAGE_KEY='pageExtractorFields',PANEL_ID='pex-panel',PREVIEW_ID='pex-preview',STYLE_ID='pex-style';
var ep=document.getElementById(PANEL_ID);
if(ep){ep.remove();var epr=document.getElementById(PREVIEW_ID);if(epr)epr.remove();var eps=document.getElementById(STYLE_ID);if(eps)eps.remove();document.body.style.cursor='';return;}
var fields=[],pickIdx=null,hlEl=null,previewVisible=false;
try{fields=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');}catch(e){fields=[];}
if(fields.length&&!fields.some(function(f){return f.format==='url';})){fields.push({label:'Page URL',selector:'',attribute:'text',format:'url'});save();}
var layout='row';
try{layout=localStorage.getItem('pageExtractorLayout')||'row';}catch(e){}
function setLayout(v){layout=v;try{localStorage.setItem('pageExtractorLayout',v);}catch(e){}}
function bringToFront(el){[PANEL_ID,PREVIEW_ID].forEach(function(id){var e=document.getElementById(id);if(e)e.style.zIndex='2147483646';});el.style.zIndex='2147483647';}
function save(){localStorage.setItem(STORAGE_KEY,JSON.stringify(fields));}
function esc(v){return String(v||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function ic(d){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>';}
var PLUS_IC=ic('<path d="M12 5v14M5 12h14"/>');
var BLANK_IC=ic('<rect x="3" y="7" width="18" height="10" rx="2" stroke-dasharray="3.5 3"/>');
var X_IC=ic('<path d="M18 6 6 18M6 6l12 12"/>');
var UP_IC=ic('<path d="m6 15 6-6 6 6"/>');
var DOWN_IC=ic('<path d="m6 9 6 6 6-6"/>');
var PICK_IC=ic('<circle cx="12" cy="12" r="7"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3"/>');
var COPY_IC=ic('<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>');
function defAttr(el){var t=el.tagName.toLowerCase();return t==='time'?'datetime':t==='a'?'href':t==='img'?'src':t==='meta'?'content':'text';}
function genSel(tgt){
  if(tgt.closest&&tgt.closest('#'+PANEL_ID))return null;
  if(tgt.id&&tgt.id.length<40&&!/^\\d/.test(tgt.id)&&!/[a-f0-9]{8,}/.test(tgt.id)){try{var s='#'+CSS.escape(tgt.id);if(document.querySelector(s)===tgt)return s;}catch(e){}}
  function desc(el){var tag=el.tagName.toLowerCase();var cls=Array.from(el.classList).filter(function(c){return c.length>1&&!/^(is-|has-|js-)/.test(c)&&!/^(active|selected|open|closed|hover|focus|visible|hidden|disabled|loading|current|expanded|collapsed|show|hide|first|last|odd|even|highlighted|featured)$/.test(c);});if(cls.length>0){try{return tag+'.'+cls.slice(0,2).map(CSS.escape).join('.');}catch(e){}}return tag;}
  var path=[],cur=tgt;
  while(cur&&cur!==document.body&&cur!==document.documentElement){path.unshift(cur);cur=cur.parentElement;}
  for(var i=path.length-1;i>=0;i--){var cand=path.slice(i).map(desc).join(' > ');try{var m=document.querySelectorAll(cand);if(m.length===1&&m[0]===tgt)return cand;}catch(e){}}
  return path.map(desc).join(' > ');
}
function autoDerive(el,f){
  var tag=el.tagName.toLowerCase();
  if(/^h[1-6]$/.test(tag)){f.label=tag==='h1'?'Title':'Heading';f.attribute='text';f.format=tag;}
  else if(tag==='a'){f.label='Link';f.attribute='href';f.format='link';}
  else if(tag==='img'){f.label='Image';f.attribute='src';f.format='image';}
  else if(tag==='time'){f.label='Date';f.attribute='datetime';f.format='plain';}
  else if(tag==='blockquote'){f.label='Quote';f.attribute='text';f.format='quote';}
  else if(tag==='table'){f.label='Table';f.attribute='text';f.format='table';}
  else if(tag==='ul'){f.label='List';f.attribute='text';f.format='ul';}
  else if(tag==='ol'){f.label='List';f.attribute='text';f.format='ol';}
  else if(tag==='em'||tag==='i'){f.label='Italic';f.attribute='text';f.format='italic';}
  else if(tag==='mark'){f.label='Highlight';f.attribute='text';f.format='highlight';}
  else{f.label='Content';f.attribute=defAttr(el);f.format='plain';}
}
function getTableMd(el){
  var rows=Array.from(el.querySelectorAll('tr'));if(!rows.length)return '';
  var tbl=rows.map(function(row){
    var cells=Array.from(row.querySelectorAll('th,td')).map(function(c){return (c.innerText||c.textContent||'').trim().replace(/\\|/g,'\\\\|').replace(/\\n/g,' ');});
    return '| '+cells.join(' | ')+' |';
  });
  if(tbl.length>1){
    var headCells=Array.from(rows[0].querySelectorAll('th,td'));
    var probeCells=rows.length>1?Array.from(rows[1].querySelectorAll('th,td')):headCells;
    var sep=headCells.map(function(_,i){
      var c=probeCells[i]||headCells[i];
      var a=c&&c.getAttribute&&c.getAttribute('align');
      if(!a){try{a=(window.getComputedStyle(c).textAlign||'').toLowerCase();}catch(e){a='';}}
      if(a==='center')return ':---:';
      if(a==='right'||a==='end')return '---:';
      if(a==='left'||a==='start')return ':---';
      return '---';
    });
    tbl.splice(1,0,'| '+sep.join(' | ')+' |');
  }
  return tbl.join('\\n');
}
function getListMd(el,ordered){
  return Array.from(el.querySelectorAll(':scope > li')).map(function(li,idx){
    var t=(li.innerText||li.textContent||'').trim().split('\\n')[0].trim();
    return (ordered?(idx+1)+'. ':'- ')+t;
  }).join('\\n');
}
function getVal(sel,attr,fmt){
  if(!sel)return '';
  try{
    var el=document.querySelector(sel);if(!el)return '';
    if(fmt==='table')return getTableMd(el);
    if(fmt==='ul')return getListMd(el,false);
    if(fmt==='ol')return getListMd(el,true);
    if(attr==='href')return el.href||el.getAttribute('href')||'';
    if(attr==='src')return el.src||el.getAttribute('src')||'';
    if(attr==='datetime')return el.getAttribute('datetime')||el.innerText||'';
    if(attr==='content')return el.getAttribute('content')||'';
    return (el.innerText||el.textContent||'').trim().replace(/\\s+/g,' ');
  }catch(e){return '';}
}
function fmtMd(f,v){
  if(f.format==='blank')return '';
  if(f.format==='url')return '**'+(f.label||'URL')+':** '+window.location.href;
  if(!v)return '';
  switch(f.format){
    case 'h1':return '# '+v;
    case 'h2':return '## '+v;
    case 'h3':return '### '+v;
    case 'h4':return '#### '+v;
    case 'h5':return '##### '+v;
    case 'h6':return '###### '+v;
    case 'link':return '['+f.label+']('+v+')';
    case 'image':return '!['+f.label+']('+v+')';
    case 'italic':return '*'+v+'*';
    case 'quote':return '> '+v.split('\\n').join('\\n> ');
    case 'highlight':return '=='+v+'==';
    case 'ul':case 'ol':case 'table':return v;
    case 'plain':return v;
    default:return '**'+f.label+':** '+v;
  }
}
function fmtCell(f,v){
  if(f.format==='blank')return '';
  if(f.format==='url')return window.location.href;
  return String(v||'').replace(/[\\t\\n\\r]+/g,' ').trim();
}
function buildOut(mode){
  if(mode==='row')return fields.map(function(f){return fmtCell(f,getVal(f.selector,f.attribute,f.format));}).join('\\t');
  return fields.map(function(f){return fmtMd(f,getVal(f.selector,f.attribute,f.format)||'(not found)');}).filter(Boolean).join('\\n\\n');
}
function copyText(t,cb){if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(t).then(cb).catch(function(){fbCopy(t);if(cb)cb();});}else{fbCopy(t);if(cb)cb();}}
function fbCopy(t){var ta=document.createElement('textarea');ta.value=t;ta.style.cssText='position:fixed;top:-9999px;left:-9999px;opacity:0;';document.body.appendChild(ta);ta.select();document.execCommand('copy');document.body.removeChild(ta);}
var FMT_OPTS=[['bold','Label + text (**bold**)'],['plain','Plain text'],['h1','Heading 1 (#)'],['h2','Heading 2 (##)'],['h3','Heading 3 (###)'],['h4','Heading 4 (####)'],['h5','Heading 5 (#####)'],['h6','Heading 6 (######)'],['link','Link (paste as URL)'],['image','Image'],['quote','Quote (>)'],['italic','Italic (*)'],['highlight','Highlight (==)'],['ul','Bullet list'],['ol','Numbered list'],['table','Table'],['blank','Blank cell'],['url','Page URL']];
var ATTR_OPTS=[['text','text'],['href','href'],['src','src'],['datetime','datetime'],['content','content']];
function makeSelect(name,i,opts,curVal,maxW){
  var lbl=(opts.find(function(o){return o[0]===curVal;})||opts[0]||['','—'])[1];
  return '<div style="position:relative;display:inline-flex;vertical-align:middle;flex-shrink:0;">'+
    '<button data-a="dd-trg" data-sel="'+name+'" data-i="'+i+'" '+
      'style="background:transparent;border:none;border-radius:6px;color:${p.muted};padding:3px 8px;font-size:11px;font-family:Arial,sans-serif;cursor:pointer;white-space:nowrap;max-width:'+(maxW||90)+'px;overflow:hidden;text-overflow:ellipsis;display:block;">'+
      esc(lbl)+' &#9662;'+
    '</button>'+
    '<div class="pex-dd-pn" id="pex-dd-'+name+'-'+i+'" '+
      'style="display:none;position:fixed;z-index:2147483648;background:${p.bg};border-radius:6px;box-shadow:0 4px 16px rgba(0,0,0,0.3);overflow:hidden;min-width:110px;">'+
      opts.map(function(o){var sel=(o[0]===curVal);
        return '<div data-a="dd-opt" data-sel="'+name+'" data-i="'+i+'" data-v="'+o[0]+'" '+
          'style="padding:5px 12px;font-size:11px;cursor:pointer;white-space:nowrap;color:'+(sel?'${p.accent}':'${p.muted}')+';">'+
          (sel?'&#10003; ':'   ')+o[1]+'</div>';
      }).join('')+
    '</div>'+
  '</div>';
}
var ddTimer=null;
function showDd(trg){
  clearTimeout(ddTimer);ddTimer=null;
  var id='pex-dd-'+trg.getAttribute('data-sel')+'-'+trg.getAttribute('data-i');
  document.querySelectorAll('.pex-dd-pn').forEach(function(el){if(el.id!==id)el.style.display='none';});
  var pn=document.getElementById(id);if(!pn)return;
  var r=trg.getBoundingClientRect();
  pn.style.left=r.left+'px';pn.style.top=(r.bottom+3)+'px';pn.style.display='block';
}
function hideDds(){
  ddTimer=setTimeout(function(){
    document.querySelectorAll('.pex-dd-pn').forEach(function(el){el.style.display='none';});
    ddTimer=null;
  },120);
}
function onDdOver(e){
  var t=e.target;
  var trg=t.closest?t.closest('[data-a="dd-trg"]'):null;
  if(trg){showDd(trg);return;}
  if(t.closest&&t.closest('.pex-dd-pn')){clearTimeout(ddTimer);ddTimer=null;}
}
function onDdOut(e){
  var rt=e.relatedTarget;
  var inTrg=e.target.closest&&e.target.closest('[data-a="dd-trg"]');
  var inPn=e.target.closest&&e.target.closest('.pex-dd-pn');
  if(!inTrg&&!inPn)return;
  if(rt&&rt.closest&&(rt.closest('[data-a="dd-trg"]')||rt.closest('.pex-dd-pn')))return;
  hideDds();
}
function renderPreview(){
  var preview=document.getElementById(PREVIEW_ID);
  if(!previewVisible||!fields.length){if(preview)preview.remove();return;}
  if(!preview){
    preview=document.createElement('div');
    preview.id=PREVIEW_ID;
    var panel=document.getElementById(PANEL_ID);
    var posTop='20px',posLeft='10px';
    if(panel){
      var rect=panel.getBoundingClientRect();
      posTop=rect.top+'px';
      posLeft=Math.max(10,rect.left-380)+'px';
    }
    preview.style.cssText='position:fixed;top:'+posTop+';left:'+posLeft+';width:370px;background:${p.bg};border-radius:14px;box-shadow:0 4px 16px rgba(0,0,0,0.28),0 8px 24px rgba(0,0,0,0.22);font-family:Arial,sans-serif;font-size:13px;z-index:2147483646;overflow:hidden;display:flex;flex-direction:column;';
    document.body.appendChild(preview);
    preview.addEventListener('mousedown',function(){bringToFront(preview);});
  }
  var mdOut=buildOut(layout);
  var preHtml=layout==='row'?esc(mdOut).replace(/\\t/g,' <span style="color:${p.dim};">&#8594;</span> '):esc(mdOut);
  preview.innerHTML=
    '<div id="pex-preview-drag" style="padding:8px 14px;display:flex;justify-content:space-between;align-items:center;cursor:move;user-select:none;">'+
    '<span style="font-size:11px;color:${p.dim};">'+(layout==='row'?'Excel Row Preview':'Document Preview')+'</span>'+
    '<button data-a="copy" style="background:transparent;border:none;border-radius:6px;color:${p.accent};padding:3px 9px;cursor:pointer;font-size:11px;">'+COPY_IC+' Copy</button>'+
    '</div>'+
    '<pre style="margin:0;padding:4px 14px 12px;font-size:10px;color:${p.code};max-height:180px;overflow-y:auto;white-space:pre-wrap;word-break:break-all;font-family:monospace;line-height:1.5;">'+preHtml+'</pre>';
  setupDrag(preview,document.getElementById('pex-preview-drag'));
  preview.onclick=function(e){
    if(e.target.getAttribute('data-a')==='copy'){
      var t=buildOut(layout);copyText(t,function(){e.target.textContent='✓ Copied!';setTimeout(function(){e.target.innerHTML=COPY_IC+' Copy';},1600);});
    }
  };
}
function renderPanel(){
  var panel=document.getElementById(PANEL_ID);if(!panel)return;
  var prevScroll=0;var fd=document.getElementById('pex-fields');if(fd)prevScroll=fd.scrollTop;
  var fHtml=fields.map(function(f,i){
    var isP=pickIdx===i;
    var fmt=f.format||'plain';
    var noSel=fmt==='blank'||fmt==='url';
    var prev=fmt==='url'?window.location.href:fmt==='blank'?'':getVal(f.selector,f.attribute,f.format);
    var isLast=i===fields.length-1;
    var mvBtn=function(a,dis){return '<button data-a="'+a+'" data-i="'+i+'" '+(dis?'disabled ':'')+'title="Move '+(a==='up'?'Up':'Down')+'" style="background:transparent;border:none;color:${p.muted};padding:4px 3px;cursor:'+(dis?'default':'pointer')+';line-height:1;flex-shrink:0;'+(dis?'opacity:0.3;':'')+'">'+(a==='up'?UP_IC:DOWN_IC)+'</button>';};
    return '<div style="padding:8px 0;'+(isLast?'':'border-bottom:1px solid rgba(128,128,128,0.1);')+'">'+
      '<div style="display:flex;gap:4px;'+(fmt==='blank'?'':'margin-bottom:5px;')+'align-items:center;">'+
      (fmt==='blank'
        ?'<span style="flex:1;min-width:0;color:${p.dim};padding:4px 6px;font-size:12px;font-style:italic;">Blank cell &#8212; leaves a gap when pasted</span>'
        :'<input data-a="label" data-i="'+i+'" value="'+esc(f.label)+'" placeholder="Label" style="flex:1;min-width:0;background:transparent;border:none;color:${p.text};padding:4px 6px;font-size:12px;font-family:Arial,sans-serif;">')+
      makeSelect('format',i,FMT_OPTS,fmt,140)+
      mvBtn('up',i===0)+
      mvBtn('down',isLast)+
      '<button data-a="delete" data-i="'+i+'" title="Remove Field" style="background:transparent;border:none;color:${p.muted};padding:4px 5px;cursor:pointer;line-height:1;flex-shrink:0;">'+X_IC+'</button>'+
      '</div>'+
      (noSel?'':'<div style="display:flex;gap:5px;align-items:center;">'+
      '<input data-a="selector" data-i="'+i+'" value="'+esc(f.selector||'')+'" placeholder="CSS selector" style="flex:1;min-width:0;background:transparent;border:none;color:${p.code};padding:4px 6px;font-size:11px;font-family:monospace;">'+
      makeSelect('attribute',i,ATTR_OPTS,f.attribute,70)+
      '<button data-a="pick" data-i="'+i+'" title="Click an Element on the Page to Capture It" style="background:'+(isP?'${p.accentBg}':'transparent')+';border:none;border-radius:6px;color:'+(isP?'${p.accent}':'${p.muted}')+';padding:4px 8px;cursor:pointer;font-size:11px;white-space:nowrap;flex-shrink:0;">'+PICK_IC+(isP?' Picking…':' Pick')+'</button>'+
      '</div>')+
      (fmt==='blank'?'':'<div style="margin-top:4px;font-size:11px;color:${p.dim};white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+
      (prev?'<span style="color:${p.success};">&#8594; </span>'+esc(prev.substring(0,80))+(prev.length>80?'&#8230;':''):'<span style="color:${p.subtle};font-style:italic;">No Match</span>')+
      '</div>')+'</div>';
  }).join('');
  panel.innerHTML=
    '<div id="pex-drag" style="padding:10px 14px;display:flex;justify-content:space-between;align-items:center;cursor:move;user-select:none;">'+
    '<span style="font-weight:600;font-size:13px;color:${p.text};">Learn Page</span>'+
    '<div style="display:flex;gap:4px;align-items:center;">'+
    '<span style="font-size:11px;color:${p.dim};">'+fields.length+' field'+(fields.length!==1?'s':'')+'</span>'+
    '<button data-a="addpick" title="Add a Field &amp; Pick It on the Page" style="background:transparent;border:none;color:${p.accent};cursor:pointer;line-height:1;padding:4px 6px;">'+PLUS_IC+'</button>'+
    '<button data-a="addblank" title="Add a Blank Cell (leaves an empty gap when pasted)" style="background:transparent;border:none;color:${p.accent};cursor:pointer;line-height:1;padding:4px 6px;">'+BLANK_IC+'</button>'+
    '<button data-a="close" title="Close" style="background:transparent;border:none;color:${p.dim};cursor:pointer;line-height:1;padding:4px 5px;">'+X_IC+'</button>'+
    '</div></div>'+
    (pickIdx!==null?'<div style="background:${p.accentBg};color:${p.accent};padding:6px 14px;font-size:12px;text-align:center;">Click an element on the page &#8212; Esc to Cancel</div>':'')+
    '<div id="pex-fields" style="padding:4px 12px 8px;overflow-y:auto;max-height:360px;">'+
    (fHtml||'<div style="color:${p.dim};text-align:center;padding:24px 0;font-size:12px;">Click + to Add Your First Field</div>')+
    '</div>'+
    '<div style="padding:7px 14px;display:flex;justify-content:space-between;align-items:center;border-top:1px solid rgba(128,128,128,0.1);">'+
    '<button data-a="clear" style="background:transparent;border:none;color:${p.muted};padding:3px 0;cursor:pointer;font-size:11px;">Clear All</button>'+
    '<button data-a="layout" title="How Extract pastes: one row across Excel columns, or top-to-bottom for a document" style="background:transparent;border:none;color:${p.muted};padding:3px 0;cursor:pointer;font-size:11px;">Pastes as: '+(layout==='row'?'Excel Row':'Document')+'</button>'+
    '<button data-a="toggle-preview" style="background:transparent;border:none;color:${p.accent};padding:3px 0;cursor:pointer;font-size:11px;">'+(previewVisible?'Hide Preview':'Show Preview')+'</button>'+
    '</div>';
  setupDrag(panel,document.getElementById('pex-drag'));
  var newFd=document.getElementById('pex-fields');if(newFd)newFd.scrollTop=prevScroll;
  renderPreview();
}
function setupDrag(panel,handle){if(!handle)return;handle.onmousedown=function(e){if(e.target.tagName==='BUTTON'||e.target.tagName==='SELECT'||e.target.tagName==='INPUT')return;var sx=e.clientX,sy=e.clientY,sl=panel.offsetLeft,st=panel.offsetTop;function mv(e){panel.style.left=(sl+e.clientX-sx)+'px';panel.style.top=(st+e.clientY-sy)+'px';panel.style.right='auto';}function up(){document.removeEventListener('mousemove',mv);document.removeEventListener('mouseup',up);}document.addEventListener('mousemove',mv);document.addEventListener('mouseup',up);e.preventDefault();};}
function insertIdx(){var n=fields.length;return (n&&fields[n-1].format==='url')?n-1:n;}
function onClick(e){
  var a=e.target.getAttribute('data-a');if(!a)return;
  var i=parseInt(e.target.getAttribute('data-i'),10);
  if(a==='close'){cleanup();}
  else if(a==='addpick'){var ni=insertIdx();fields.splice(ni,0,{label:'Field '+(ni+1),selector:'',attribute:'text',format:'plain'});save();pickIdx=ni;startPick();renderPanel();}
  else if(a==='addblank'){fields.splice(insertIdx(),0,{label:'Blank',selector:'',attribute:'text',format:'blank'});save();renderPanel();}
  else if(a==='layout'){setLayout(layout==='row'?'doc':'row');renderPanel();}
  else if(a==='up'||a==='down'){var j=a==='up'?i-1:i+1;if(!isNaN(i)&&j>=0&&j<fields.length){var tmp=fields[i];fields[i]=fields[j];fields[j]=tmp;if(pickIdx===i)pickIdx=j;else if(pickIdx===j)pickIdx=i;save();renderPanel();}}
  else if(a==='delete'){if(pickIdx===i){pickIdx=null;stopPick();}fields.splice(i,1);save();renderPanel();}
  else if(a==='pick'){if(pickIdx===i){pickIdx=null;stopPick();}else{if(pickIdx!==null)stopPick();pickIdx=i;startPick();}renderPanel();}
  else if(a==='clear'){if(confirm('Remove all '+fields.length+' field(s)?')){fields=[];if(pickIdx!==null){pickIdx=null;stopPick();}save();renderPanel();}}
  else if(a==='toggle-preview'){previewVisible=!previewVisible;if(!previewVisible){var pv=document.getElementById(PREVIEW_ID);if(pv)pv.remove();}renderPanel();}
  else if(a==='dd-opt'){
    var sel=e.target.getAttribute('data-sel'),optI=parseInt(e.target.getAttribute('data-i'),10),v=e.target.getAttribute('data-v');
    if(!isNaN(optI)){if(sel==='format'){fields[optI].format=v;save();renderPanel();}else if(sel==='attribute'){fields[optI].attribute=v;save();renderPanel();}}
    document.querySelectorAll('.pex-dd-pn').forEach(function(el){el.style.display='none';});
  }
}
var debT=null;
function onInput(e){var a=e.target.getAttribute('data-a'),i=parseInt(e.target.getAttribute('data-i'),10);if(isNaN(i))return;if(a==='label'){fields[i].label=e.target.value;save();}else if(a==='selector'){fields[i].selector=e.target.value;save();clearTimeout(debT);debT=setTimeout(renderPanel,550);}}
function startPick(){document.addEventListener('mouseover',onHov,true);document.addEventListener('click',onPickEl,true);document.addEventListener('keydown',onKey,true);document.body.style.cursor='crosshair';}
function stopPick(){document.removeEventListener('mouseover',onHov,true);document.removeEventListener('click',onPickEl,true);document.removeEventListener('keydown',onKey,true);document.body.style.cursor='';clearHl();}
function clearHl(){if(hlEl){hlEl.style.outline=hlEl._pexOut||'';hlEl.style.outlineOffset=hlEl._pexOff||'';delete hlEl._pexOut;delete hlEl._pexOff;hlEl=null;}}
function onHov(e){var t=e.target;if(t.closest&&(t.closest('#'+PANEL_ID)||t.closest('#'+PREVIEW_ID)))return;clearHl();hlEl=t;t._pexOut=t.style.outline;t._pexOff=t.style.outlineOffset;t.style.outline='2px solid ${p.accent}';t.style.outlineOffset='2px';}
function onPickEl(e){
  var t=e.target;
  if(t.closest&&(t.closest('#'+PANEL_ID)||t.closest('#'+PREVIEW_ID))){
    if(pickIdx!==null){e.preventDefault();e.stopPropagation();pickIdx=null;stopPick();renderPanel();}
    return;
  }
  e.preventDefault();e.stopPropagation();
  if(pickIdx===null)return;
  var sel=genSel(t);
  if(sel){fields[pickIdx].selector=sel;autoDerive(t,fields[pickIdx]);save();}
  var ni=insertIdx();
  fields.splice(ni,0,{label:'Field '+(ni+1),selector:'',attribute:'text',format:'plain'});
  save();pickIdx=ni;startPick();renderPanel();
}
function onKey(e){if(e.key==='Escape'){pickIdx=null;stopPick();renderPanel();}}
function cleanup(){
  stopPick();
  var pn=document.getElementById(PANEL_ID);if(pn)pn.remove();
  var pv=document.getElementById(PREVIEW_ID);if(pv)pv.remove();
  var ps=document.getElementById(STYLE_ID);if(ps)ps.remove();
}
var pexStyle=document.createElement('style');
pexStyle.id=STYLE_ID;
pexStyle.textContent='#pex-panel input,#pex-panel button,#pex-preview button{transition:background-color 0.28s cubic-bezier(0.22,1,0.36,1),box-shadow 0.28s cubic-bezier(0.22,1,0.36,1),transform 0.28s cubic-bezier(0.22,1,0.36,1);}#pex-panel button,#pex-preview button{border-radius:6px;box-shadow:none;display:inline-flex;align-items:center;justify-content:center;gap:5px;}#pex-panel button:hover,#pex-preview button:hover{background-color:${p.surface}!important;box-shadow:0 2px 8px rgba(0,0,0,0.28)!important;}#pex-panel button:active,#pex-preview button:active{transform:scale(0.97);transition-duration:0s;}#pex-panel input:focus{outline:none;}#pex-panel [data-a="dd-trg"]:hover{background-color:${p.surface}!important;box-shadow:0 2px 8px rgba(0,0,0,0.28)!important;}.pex-dd-pn [data-a="dd-opt"]:hover{background-color:${p.surface}!important;}'+
'#pex-panel svg,#pex-preview svg{width:13px;height:13px;display:block;pointer-events:none;flex-shrink:0;}'+
'#pex-panel,#pex-panel *,#pex-preview,#pex-preview *{scrollbar-width:none!important;-ms-overflow-style:none!important;}'+
'#pex-panel::-webkit-scrollbar,#pex-panel *::-webkit-scrollbar,#pex-preview::-webkit-scrollbar,#pex-preview *::-webkit-scrollbar{display:none!important;width:0!important;height:0!important;}';
document.head.appendChild(pexStyle);
var panel=document.createElement('div');
panel.id=PANEL_ID;
panel.style.cssText='position:fixed;top:20px;right:20px;width:370px;background:${p.bg};border-radius:14px;box-shadow:0 4px 16px rgba(0,0,0,0.28),0 8px 24px rgba(0,0,0,0.22);font-family:Arial,sans-serif;font-size:13px;z-index:2147483647;overflow:hidden;display:flex;flex-direction:column;';
panel.addEventListener('mousedown',function(){bringToFront(panel);});
panel.addEventListener('click',onClick);
panel.addEventListener('input',onInput);
panel.addEventListener('mouseover',onDdOver);
panel.addEventListener('mouseout',onDdOut);
document.body.appendChild(panel);
renderPanel();
if(!fields.length){fields.push({label:'Field 1',selector:'',attribute:'text',format:'plain'});fields.push({label:'Page URL',selector:'',attribute:'text',format:'url'});save();pickIdx=0;startPick();renderPanel();}
})();`;
}
